<template>
<header>
    <div :class="$style.header">
        <header-logo />
        <header-nav />
        <header-action />
    </div>
    <breadcrumb v-show="$route.name !== 'home'" />
</header>
</template>

<script>
import HeaderLogo from "./HeaderLogo.vue";
import HeaderNav from "./HeaderNav.vue";
import Breadcrumb from "./Breadcrumb.vue";
import HeaderAction from "./HeaderAction.vue";

export default {
    components: { HeaderLogo, HeaderNav, Breadcrumb, HeaderAction }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/variables" as v;
@use "@/assets/scss/mixins" as m;

.header {
    @include m.md {
        height: v.$app-header-height-md;
    }
    @include m.m_inner;
    display: flex;
    align-items: center;
    height: v.$app-header-height;
    padding: 0px 30px;
    background-color: v.$app-header-bg;
    color: v.$app-header-color;
}
</style>
